// extracted by mini-css-extract-plugin
export default {"arrowNext":"pagination_arrowNext__lih-N","arrowPrev":"pagination_arrowPrev__Gmw31","pages":"pagination_pages__QmyTw","currentPage":"pagination_currentPage__rKAMv"};